export interface DashboardPreferences {
  hiddenCards: string[];
  version: number;
  updatedAt?: string;
}

export const DEFAULT_DASHBOARD_PREFERENCES: DashboardPreferences = {
  hiddenCards: [],
  version: 1,
};
